export default __webpack_public_path__ + "static/media/one.cc9c4a62.svg";